import * as angular from 'angular';

import { ModalService, ModalTheme, ModalType } from '../modal.service';

export class ModalDialogController {
  static $inject = ['ModalService'];

  private content!: string;
  private buttonCancelClasses!: string;
  private buttonConfirmClasses!: string;
  private confirmButtonConfirm!: string;
  private confirmButtonCancel!: string;
  private onConfirm!: () => void;
  private onClose!: () => void;
  private modal: any;
  private modalType!: ModalType;
  private modalTheme!: ModalTheme;
  private title!: string;

  constructor(private modalService: ModalService) {}

  $onChanges(changed: angular.IOnChangesObject) {
    if (changed['open'].currentValue) {
      this.openModal();
    } else {
      this.closeModal();
    }
  }

  handleConfirm() {
    this.onConfirm();
  }

  handleDismiss() {
    this.onClose();
  }

  openModal() {
    const openMethod = this.getModalOpenMethod();
    const template = this.getModalTemplate();

    this.modal = openMethod(
      {},
      {
        template,
      }
    );

    this.modal.result.then(this.handleConfirm.bind(this)).catch(this.handleDismiss.bind(this));
  }

  getModalOpenMethod(): Function {
    let method;

    switch (this.modalType) {
      case ModalType.Default:
        method = this.modalService.open;
        break;
      case ModalType.Full:
        method = this.modalService.openFullModal;
        break;
      case ModalType.Legacy:
        method = this.modalService.openLegacy;
        break;
      default:
        method = this.modalService.open;
        break;
    }

    return method.bind(this.modalService);
  }

  getCancelButtonClasses() {
    if (this.modalThemeIs(ModalTheme.Danger) || this.modalThemeIs(ModalTheme.DangerLight)) {
      return 'btn-optional-action';
    }

    if (this.buttonCancelClasses) {
      return this.buttonCancelClasses;
    }

    return 'btn-secondary';
  }

  getConfirmButtonClasses() {
    if (this.modalThemeIs(ModalTheme.Danger)) {
      return 'btn-danger';
    }

    if (this.modalThemeIs(ModalTheme.DangerLight)) {
      return 'btn-danger-light';
    }

    if (this.buttonConfirmClasses) {
      return this.buttonConfirmClasses;
    }

    return 'btn-filled-primary';
  }

  getModalTemplate(): string {
    const templates = {
      default: `
        <div class="default-modal">
          <mode-legacy-dialog-header (closed)="$dismiss()">
            ${this.title}
          </mode-legacy-dialog-header>
          <div class="modal-container-sm">
            ${this.content}
          </div>
          <mode-legacy-dialog-footer>
            <capra-button
              variant="secondary"
              color="neutral"
              text="${this.confirmButtonCancel}"
              (clicked)="$dismiss()"
            ></capra-button>
            <capra-button
              color="${this.getConfirmButtonClasses() === 'btn-filled-primary' ? 'primary' : 'alert'}"
              text="${this.confirmButtonConfirm}"
              (clicked)="$close()"
            ></capra-button>
          </mode-legacy-dialog-footer>
        </div>
      `,
      legacy: `
        <div class="default-modal-wrap">
          <div class="default-modal">
            ${this.content}

            <div class="modal-actions">
              <a class="cancel-link" href ng-click="$dismiss()">
                ${this.confirmButtonCancel}
              </a>
              <a class="btn ${this.getConfirmButtonClasses()}" href ng-click="$close()">
                ${this.confirmButtonConfirm}
              </a>
            </div>
          </div>
        </div>
      `,
    };

    switch (this.modalType) {
      case ModalType.Legacy:
        return templates.legacy;
      default:
        return templates.default;
    }
  }

  closeModal() {
    if (this.modal) {
      this.modal.close();
      this.modal = null;
    }
  }

  modalThemeIs(modalTheme: ModalTheme): boolean {
    return this.modalTheme && this.modalTheme === modalTheme;
  }
}

export const ModalDialogComponent: angular.IComponentOptions = {
  controller: ModalDialogController,
  controllerAs: 'ctrl',
  bindings: {
    buttonCancelClasses: '@',
    buttonConfirmClasses: '@',
    confirmButtonCancel: '@',
    confirmButtonConfirm: '@',
    content: '<',
    modalType: '@',
    modalTheme: '@',
    onClose: '&?',
    onConfirm: '&?',
    onOpen: '&',
    open: '<',
    title: '<',
  },
};
